import { parsePhoneNumber } from 'libphonenumber-js/mobile';

export const checkPhoneValidation = (dialCode: string = '', number: string = '') => {
	try {
		if (!number) return false;
		const phoneNumber = parsePhoneNumber( '+' + dialCode + number);
		return phoneNumber && phoneNumber.isValid() ? true : false;
	} catch (error) {
		return false;
	}
};
